export const FRANCHISE_SECTIONS = [
  { id: 's-hero', title: 'SUSHIBOX на карте' },
  /* { id: 's-map', title: 'Карта' }, */
  { id: 's-about', title: 'Экономика в цифрах' },
  /* { id: 's-why-now', title: 'Почему сейчас' },
  { id: 's-product', title: 'Продукт' },
  { id: 's-economy-new', title: 'Экономика' },
  { id: 's-marketing', title: 'Маркетинг' },
  { id: 's-why-us', title: 'Почему мы' },
  { id: 's-start', title: 'Запуск' }, */
  { id: 's-sucsess', title: 'Истории партнеров' },
  /* { id: 's-conditions-new', title: 'Условия' }, */
  { id: 's-partners', title: 'Кто наш партнер' },
  { id: 's-final', title: 'Связаться' },
  /* { id: 's-company', title: 'О компании' },
  { id: 's-geography', title: 'География и рост' },
  { id: 's-economy', title: 'Экономика точки' },
  { id: 's-conditions', title: 'Условия партнёрства' }, */
];

export const FRANCHISE_SECTION_IDS = FRANCHISE_SECTIONS.map((s) => s.id);
